
/**
 * 橙意满满
 */
export namespace ChengYiKind {

    export enum GeneralValue {
        /** 最大牌数 */
        CardCount = 10,
    }

    /** 牌型 */
    export enum CardType {
        Min = 1,
        /** 橙子 */
        ORANGE, 
        /** 葡萄 */
        GRAPE, 
        /** 西瓜 */
        WATERMELON, 
        /** 香蕉 */
        BANANA, 
        Max,
    }

    /** 牌型信息 */
    class CardTypeInfo {
        /** 名称 */
        name?: string = '';
        /** 图片 */
        icon: string = '';
    }

    /** 牌型信息 */
    export const CardTypeInfoArr = {
        /** 橙子 */
        [CardType.ORANGE]: {
            icon: 'spr_orange_gray'
        }, 
        /** 葡萄 */
        [CardType.GRAPE]: {
            icon: 'spr_grape'
        },
        /** 西瓜 */
        [CardType.WATERMELON]: {
            icon: 'spr_watermelon'
        },
        /** 香蕉 */
        [CardType.BANANA]: {
            icon: 'spr_banana'
        },
    }

    /** 中奖概率信息 */
    class WinProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 金额 */
        sum: number = 0;
        /** 橙子数量 */
        count: number = 0;
    }

    /** 中奖概率 */
    export const WinProb: WinProbInfo[] = [
        {
            prob: 0.285
            , sum: 0
            , count: 1
        },
        {
            prob: 0.04
            , sum: 66000
            , count: 0
        },
        {
            prob: 0.15
            , sum: 500
            , count: 3
        },
        {
            prob: 0.15
            , sum: 1000
            , count: 4
        },
        {
            prob: 0.1
            , sum: 1888
            , count: 5
        },
        {
            prob: 0.15
            , sum: 2888
            , count: 6
        },
        {
            prob: 0.05
            , sum: 6666
            , count: 7
        },
        {
            prob: 0.04
            , sum: 18000
            , count: 8
        },
        {
            prob: 0.03
            , sum: 100000
            , count: 9
        },
        {
            prob: 0.005
            , sum: 1000000
            , count: 10
        },
    ];

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number = 0;
    }

}

